function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".NoProduct_svg__cls-4{fill:#72c1f7}.NoProduct_svg__cls-5{fill:#64b6ee}.NoProduct_svg__cls-7{fill:#cbe9ff}.NoProduct_svg__cls-8{fill:#88cdfa}"));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "NoProduct_svg__illustration-copy"
}, React.createElement("ellipse", {
  id: "NoProduct_svg__ellipse-1",
  cx: 77,
  cy: 197,
  rx: 77,
  ry: 8,
  fill: "#ecf0f3"
}), React.createElement("path", {
  d: "M29.454 115.246h94.279l14.964 9.031H11.496l17.958-9.031z",
  id: "NoProduct_svg__path-1",
  className: "NoProduct_svg__cls-4",
  fillRule: "evenodd"
}), React.createElement("path", {
  id: "NoProduct_svg__rect-1",
  className: "NoProduct_svg__cls-5",
  d: "M27 116h96v53H27z"
}), React.createElement("path", {
  d: "M11.5 124.312h49.406v75.219H11.5v-75.219zm127.219 75.219H92.312v-75.219h46.407v75.219z",
  id: "NoProduct_svg__path-2",
  className: "NoProduct_svg__cls-7",
  fillRule: "evenodd"
}), React.createElement("path", {
  id: "NoProduct_svg__rect-2",
  className: "NoProduct_svg__cls-8",
  d: "M60 124h33v76H60z"
}), React.createElement("path", {
  d: "M6.582 66.066l131.54 35.449-16.392 3.373L19.1 77.231 6.582 66.066z",
  id: "NoProduct_svg__path-3",
  className: "NoProduct_svg__cls-4",
  fillRule: "evenodd"
}), React.createElement("path", {
  d: "M21.037 69.962l102.63 27.657-1.937 7.269L19.1 77.231l1.937-7.269z",
  id: "NoProduct_svg__path-4",
  className: "NoProduct_svg__cls-5",
  fillRule: "evenodd"
}), React.createElement("path", {
  d: "M16.265 29.722L147.804 65.17l-9.682 36.345L6.582 66.066l9.683-36.344z",
  id: "NoProduct_svg__path-5",
  className: "NoProduct_svg__cls-7",
  fillRule: "evenodd"
}), React.createElement("path", {
  d: "M66.857 43.356l31.801 8.57-9.683 36.344-31.801-8.57 9.683-36.344z",
  id: "NoProduct_svg__path-6",
  className: "NoProduct_svg__cls-8",
  fillRule: "evenodd"
}), React.createElement("path", {
  d: "M73.449 39.859c-3.454-.346-10.442-4.513-14.91-7.869-2.027-1.52-9.35-9.047-8.738-17.844.546-7.851 4.591-12.367 12.605-13.894 4.118-.786 8.323.502 8.323.502s5.553 1.325 8.115 4.206c7.74 8.702 6.713 14.355 5.844 19.488-.852 5.037.755 9.825-.462 12.185l2.856.769c.27-2.892 3.439-5.646 6.225-8.899 3.472-4.055 9.639-5.761 9.639-5.761s4.821-2.258 8.896-2.53c6.469-.842 13.347 3.305 14.88 5.449 2.688 3.761 5.705 10.059 5.705 10.059s.606 5.813-1.934 9.459c-2.525 3.628-5.035 4.047-9.133 5.918-4.172 1.904-9.519 1.332-16.644.181-4.981-.806-9.686-.825-12.009-3.335M60.755 27.572c3.061 3.546 13.056 10.841 13.056 10.841l.029.03 1.186-4.29 4.805 1.295c.051-1.955 1.175-13.836-1.272-21.156-2.333-6.98-11.027-10.589-17.901-8.154-6.572 2.327-10.006 9.729.097 21.434zm30.241 10.886l3.505.944-1.321 6.289c.919-.141 14.189 1.814 18.531 1.552 12.602-.76 16.55-8.388 14.139-14.264-4.169-10.161-11.875-8.863-20.288-4.447-14.765 7.752-14.057 10.412-14.566 9.926z",
  id: "NoProduct_svg__path-7",
  className: "NoProduct_svg__cls-8",
  fillRule: "evenodd"
}), React.createElement("path", {
  d: "M74.292 32.894l21.682 5.843-3.098 11.63-21.683-5.843 3.099-11.63z",
  id: "NoProduct_svg__path-8",
  className: "NoProduct_svg__cls-5",
  fillRule: "evenodd"
}));

var SvgNoProduct = function SvgNoProduct(props) {
  return React.createElement("svg", _extends({
    preserveAspectRatio: "xMidYMid",
    width: 153,
    height: 204,
    viewBox: "0 0 153 204"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "media/NoProduct.d23d44e7.svg";
export { SvgNoProduct as ReactComponent };